import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { User, Plus } from "lucide-react";
import type { DealsFunnelLeadPlaceholder } from "@/hooks/useDealsFunnelLeadsWithoutDeal";

interface DealLeadPlaceholderCardProps {
  lead: DealsFunnelLeadPlaceholder;
  onClick: (lead: DealsFunnelLeadPlaceholder) => void;
}

export function DealLeadPlaceholderCard({ lead, onClick }: DealLeadPlaceholderCardProps) {
  return (
    <Card
      className="cursor-pointer hover:shadow-md transition-shadow border border-dashed bg-background/60 group"
      onClick={() => onClick(lead)}
    >
      <CardContent className="p-3 space-y-2">
        <div className="flex items-start justify-between gap-2">
          <p className="font-medium text-sm truncate group-hover:text-primary transition-colors">{lead.name}</p>
          <Badge variant="secondary" className="text-[10px] px-1.5 py-0 shrink-0">Lead</Badge>
        </div>
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <User className="w-3 h-3" />
          <span className="truncate">{lead.phone || lead.email || "Sem contato"}</span>
        </div>
        <div className="flex items-center gap-1 text-[10px] text-muted-foreground">
          <Plus className="w-3 h-3" />
          Criar negociação
        </div>
      </CardContent>
    </Card>
  );
}
